import queryString from 'query-string';
import { useEffect, useState } from 'react';
import { Card, Tabs } from '@mantine/core';
import { useLocation, useNavigate, useParams } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import RecommenderResponse from '../../components/Recommenders/RecommenderResponse';
import Spinner from '../../components/Spinner';
import useFetch from '../../helpers/useFetch';

const ProfilesDetailsRecommendationsPage = ({ profile }) => {
  const location = useLocation();
  const fetch = useFetch();
  const navigate = useNavigate();

  const search = queryString.parse(location.search);
  const [recommendations, setRecommendations] = useState();
  const [error, setError] = useState();
  const recommendationTab = search.recommendationTab;
  const { accountId, domainId } = useParams();

  useEffect(() => {
    setRecommendations(undefined);
    fetch(
      `/api/admin/accounts/${accountId}/domains/${domainId}/profiles/recommendations?profileId=${encodeURIComponent(
        profile.profileId
      )}`,
      {}
    )
      .then(({ recommendations }) => {
        setRecommendations(recommendations);
      })
      .catch(setError);
  }, [accountId, domainId, fetch, profile.email, profile.profileId]);

  if (error) {
    return <ErrorMessage message={error.message} />;
  }

  if (recommendations === undefined) {
    return <Spinner />;
  }

  const setRecommendationTab = (recommendationTab) => {
    navigate(
      `${location.pathname}?${queryString.stringify({
        ...search,
        recommendationTab,
      })}`
    );
  };

  return (
    <Tabs value={recommendationTab} onChange={setRecommendationTab} m={0}>
      <Tabs.List>
        {recommendations.map((rec, i) => (
          <Tabs.Tab key={i} value={rec.meta.algorithm}>
            {rec.name}
          </Tabs.Tab>
        ))}
      </Tabs.List>
      {recommendations.map((rec, i) => (
        <Tabs.Panel key={i} value={rec.meta.algorithm}>
          <Card withBorder>
            <RecommenderResponse recommendation={rec} disableWrapper={true} />
          </Card>
        </Tabs.Panel>
      ))}
    </Tabs>
  );
};

export default ProfilesDetailsRecommendationsPage;
